import React from 'react'
import { Loading } from '../../../redux/action';
import { connect } from 'react-redux';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Methods } from '../../../core/utility';

interface Props{
    UserReducer: any;
    loading: (data: any) => void;
    amountGraph:any;
}
const methods = new Methods()
const EmvROI:React.FC<Props> = (props: Props) => {
//   const maxEngagement = Math.max(
//   ...props.amountGraph.datasets.flatMap((dataset:any) => dataset.data)
// );


// const yAxisMax = Math.ceil(maxEngagement) + 2;
// Find max value among both series
const maxEmv = Math.max(...props.amountGraph.map((entry:any) => entry.avg_emv_per_day));
const maxBudget = Math.max(...props.amountGraph.map((entry:any) => entry.avg_amount_per_day));

// Take the higher of the two
const overallMax = Math.max(maxEmv, maxBudget);

// Add some padding (for example +2 or +10% of overallMax)
const yAxisMax = Math.ceil(overallMax * 1.1); // +10% padding
    const options = {
      chart: {
        type: "column",
        height:230
      },
      title: {
        text: "",
        align:'left'

      },
      tooltip: {

        useHTML: true, // allow HTML inside tooltip
        className: 'tooltip-container',
        formatter: function (this: Highcharts.TooltipFormatterContextObject): string {
          return `
            <div class="tooltip-formatter">
              <strong class="tooltip-formatter-title" style="color:${this.color};">${this.series.name}</strong><br/>
              <span class="tooltip-formatter-value" style="font-size:13px;"><b>${methods.convertTwoPlaceExactNumber(Number(this.y))}</b></span>
            </div>
          `;
        },
        style: {
        width: '300px',  // Set the desired width
        whiteSpace: 'normal',  // Allow line breaks if needed
      }
      },
      xAxis: {
        type: "datetime",
        categories: props.amountGraph.map((entry:any) => entry.date),
      },
      yAxis: {
        title: {
          text: "EMV - ROI Ratio",
        },
        max: yAxisMax,
      },
      plotOptions: {
        column: {
        },
      },

      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: false, // Hides the export menu (dropdown)
      },
      series: [
      {
        name: "emv",
        data: props.amountGraph.map((entry:any) => entry.avg_emv_per_day),
        color: '#63ABFD',
        pointWidth: null,
        states: {
          inactive: {
            opacity: 1,  // Prevents other slices from becoming semi-transparent
          },
        },
      },
      {
        name: "budget",
        data: props.amountGraph.map((entry:any) => entry.avg_amount_per_day),
        color: '#E697FF',
        pointWidth: null,
        states: {
          inactive: {
            opacity: 1,  // Prevents other slices from becoming semi-transparent
          },
        },
      },
    ],
      
    };
  return (
    <>
                  <section className="brand-insight-highchart">
                <div className="brand-insight-highchart-top">
                  <strong className="brand-insight-highchart-title">ROI: Paid Collaboration</strong>
                </div>
                <div className="brand-insight-highchart-data">
                  <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                  />
                </div>
              </section>
    </>
  )
}

const mapStateToProps = (state: any) => {
    return {
      UserReducer: state.UserReducer.UserData,
    };
  };
  
  const mapDispatchToProps = (dispatch: any) => {
    return {
      loading: (data: any) => dispatch(Loading(data)),
    };
  };
  
  const connectToRedux = connect(mapStateToProps, mapDispatchToProps)(EmvROI);
  
  export { connectToRedux as  EmvROI };
  
  